import React from "react";

import { useDownloadDocumentContent } from "@planzone/view-models";
import { Window } from "@common/window";
import { Loader } from "@common/loader";
import { isDocx, isZip } from "@components/checkFileType";
import { DocxRenderer } from "./docxRenderer";
import { ZipRenderer } from "./zipRenderer";
import { DefaultRenderer } from "./defaultRenderer";
import { Props } from "./types";
import styles from "./styles.scss";

function Preview({ document, close }: Props) {
  const {
    isRequestPending,
    isRequestSuccess,
    isRequestFailure,
    file,
    downloadDocumentContent,
  } = useDownloadDocumentContent(document);

  React.useEffect(() => {
    !isRequestPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      downloadDocumentContent({ document });
  }, [document.uri]);

  return (
    <Window close={close}>
      <div className={styles.preview}>
        {isRequestPending ? (
          <div className={styles.loader}>
            <div>
              <Loader />
            </div>
          </div>
        ) : isDocx(document.mimeType) ? (
          <DocxRenderer document={document} file={file} />
        ) : isZip(document.mimeType) ? (
          <ZipRenderer document={document} file={file} close={close} />
        ) : (
          <DefaultRenderer document={document} file={file} />
        )}
      </div>
    </Window>
  );
}

export { Preview };
